import { render, staticRenderFns } from "./CopyEntity.vue?vue&type=template&id=2ee59d80&scoped=true&"
import script from "./CopyEntity.vue?vue&type=script&lang=js&"
export * from "./CopyEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee59d80",
  null
  
)

export default component.exports